import * as $ from 'jquery';
import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, HostListener } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
const _ = require('lodash');

import { DashboardFilter } from '../../../../../../app/models/DashboardFilter';
import { MasterConstants } from '../../../../../../app/common/constants/master-constants';

import { LocalStorageService } from './../../../../../services/infrastructure/local-storage.service';
import { LoaderService } from './../../../../../services/infrastructure/loader.service';
import { DeliveryInstructionService } from '../../../../../services/seed/delivery-Instruction.service';
import { Subscription } from 'rxjs';
import { DeliveryInstructionLandingFilterVM } from '../../../../../models/DeliveryInstructionLandingFilterVM';
import { FilterOption } from '../../../../../common/components/filter/filter-model';
import { ControlType } from '../../../../../common/components/filter/filter-enum';
import { CommonService } from '../../../../../services/common/common.service';
import { dashboradDDL } from '../../../../../models/GrowerListing';
import { LolLoggerService } from '../../../../../common/shared/lol-logger.service';

@Component({
  selector: 'app-landing-delivery-instructions',
  templateUrl: './delivery-instructions-landing.component.html',
  styleUrls: ['./delivery-instructions-landing.component.scss']
})
export class LandingDeliveryInstructionsComponent implements OnInit, AfterViewInit, OnDestroy {
  filterArray = [];
  headerYear: any;
  headerCompany = MasterConstants.US_COMPANYCODE;
  dashboardFilter: DashboardFilter;
  bodyDS: any;
  itemList: number[];
  filterOptionsData: Array<FilterOption>;
  subscription = new Subscription();

  @ViewChild('deliveryInstructionTable', { read: MatSort }) deliveryInstructionSort: MatSort;

  public deliveryInstructionList: any;
  public deliveryInstructionDataSource: MatTableDataSource<any>;
  displayedDeliveryInstructionColumns: string[] = ['accountName', 'accountNumber', 'updatedBy', 'dateUpdated'];
  deliveryInstructionFilter: DeliveryInstructionLandingFilterVM = new DeliveryInstructionLandingFilterVM();
  accessTypeMode = false;

  constructor(private router: Router,
    private localStorageService: LocalStorageService,
    private deliveryInstructionService: DeliveryInstructionService,
    private commonService: CommonService,
    private loaderService: LoaderService) {
    this.dashboardFilter = new DashboardFilter();
  }

  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setHeight();
  }

  ngOnInit() {
    // Set the default value
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }
    this.getDeliveryInstructionGridData();
    this.setFilterAndGridColumn();
    this.setDefaultFilter();

    this.accessTypeMode = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.DELIVERY_INSTRUCTIONS);
  }

  getDeliveryInstructionGridData() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(
      this.deliveryInstructionService.getDeliveryInstructionList(this.deliveryInstructionFilter).subscribe(
        (result: any[]) => {
          this.deliveryInstructionList = result.sort((a, b) => new Date(b.updateTimeStamp).getTime() - new Date(a.updateTimeStamp).getTime());
          this.deliveryInstructionDataSource = new MatTableDataSource(this.deliveryInstructionList);
          this.deliveryInstructionDataSource.sort = this.deliveryInstructionSort;

          this.loaderService.setLoaderStatus(false);
        },
        (error) => {
          this.loaderService.setLoaderStatus(false);
        }
      )
    );
  }

  setFilterAndGridColumn() {
    this.filterOptionsData = [
      {
        label: 'Account Number',
        key: 'account',
        controlType: ControlType.Integer,
      },
      {
        label: 'Account Name',
        key: 'accountName',
        controlType: ControlType.Text,
      },
      {
        label: 'Account City',
        key: 'accountCity',
        controlType: ControlType.Text,
      },
      {
        label: 'Account State',
        key: 'accountState',
        controlType: ControlType.DropDown,
        controlDataBindLabel: 'value',
        controlDataBindValue: 'id',
      },
      {
        label: 'Updated Date',
        key: 'updatedDate',
        controlType: ControlType.DateRange,
      },
      {
        label: 'Contact Name',
        key: 'contactName',
        controlType: ControlType.Text,
      },
      {
        label: 'Pallet Jack Required',
        key: 'isPalletJackReq',
        controlType: ControlType.DropDown,
        controlDataBindLabel: 'value',
        controlDataBindValue: 'id',
        isMultiSelect: false
      },
      {
        label: 'Parent Account Number',
        key: 'parentAccountNo',
        controlType: ControlType.Text,
      },

    ];;
    this.getPalletFilterData();
    this.getDropDownData();
  }

  // Set default filter values
  setDefaultFilter() {
    this.deliveryInstructionFilter = {
      account: null,
      accountName: null,
      accountCity: null,
      accountState: null,
      updatedDate: null,
      isPalletJackReq: null,
      contactName: null,
      parentAccountNo: null
    };
  }
  // Search Action
  filterSearchClick(event) {
    this.deliveryInstructionFilter = event;
    this.getDeliveryInstructionGridData();
  }

  // Clear All Action
  filterClearAllClick(event) {
    this.deliveryInstructionFilter = event;
    this.getDeliveryInstructionGridData();
  }

  getDropDownData() {
    if (this.headerCompany && this.headerYear) {
      this.subscription.add(this.commonService
        .getFilterDDLData()
        .subscribe(
          (result) => {
            const data = result as dashboradDDL;
            // setting state drop down and remove All states value from list
            this.filterOptionsData.find((x) => x.key == 'accountState').controlData = data.states;
          },
          (error) => LolLoggerService.error(error)
        ));
    }
  }

  getPalletFilterData() {
    const data = [{ id: '1', value: 'YES' }, { id: '0', value: 'NO' }];
    this.filterOptionsData.find((x) => x.key == 'isPalletJackReq').controlData =
      data;
  }
  // ngAfterViewInit
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setHeight();
  }
  // Set Height
  setHeight() {
    setTimeout(function () {
      const templateHeight = window.innerHeight - $('.account-filter').outerHeight() - $('.mat-tab-header').outerHeight() - $('.fulfill-top-sec').outerHeight() - 187;
      $('.growertableContainer').css('max-height', templateHeight + 'px');
    }, 100);
  }

  addEditDeliveryInstruction() {
    this.deliveryInstructionService.editDeliveryAccountNo = null;
    this.router.navigate(['/delivery-instructions-create-edit']);
  }

  navigateToEditDeliveryInstructions(element: any) {
    this.deliveryInstructionService.editDeliveryAccountNo = element.accountNumber;
    this.router.navigate([
      '/delivery-instructions-create-edit'
    ]);
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
